module.exports = __webpack_public_path__ + "static/assets/69c2ac9cd336c446921eca032f4ed06f.png";